import { connect } from 'react-redux';
import { IApplicationState, TTypedThunkDispatch } from '../../../../types/store';

import { changeFloorCountRange } from '../../../../store/filters/actions';
import { IFloorCountsFilterProps, FloorCountsFilter } from './floor_count_filter';

export function mapStateToProps(state: IApplicationState): Partial<IFloorCountsFilterProps> {
  return {
    floorCountFrom: state.filters.floorCountFrom ?? undefined,
    floorCountTo: state.filters.floorCountTo ?? undefined,
  };
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch): Partial<IFloorCountsFilterProps> {
  return {
    onChange: (min, max) => dispatch(changeFloorCountRange(min, max)),
  };
}

export const FloorCountsFilterContainer = connect<Partial<IFloorCountsFilterProps>, Partial<IFloorCountsFilterProps>>(
  mapStateToProps,
  mapDispatchToProps,
)(FloorCountsFilter);
